<div class="versions" [class.small]="small">
  @if (versions) {
    @for (version of versions; track version.id) {
      <a
        class="version"
        [routerLink]="[urlPrefix, version.id]"
        queryParamsHandling="preserve"
        (click)="onSelect.emit(version)"
        [class.primary]="asset.version === version.id"
        [class.active]="selectedVersion.id === version.id"
      >
        <div class="image">
          @if (asset | canDisplayAsset: version) {
            @let versionSrc =
              version
                | assetVersionUrl
                  : version.uuid
                  : version.status
                  : version.watermark_uuid
                  : 64
                  : undefined
                  : asset.watermark_enabled;

            <img [src]="versionSrc" alt="" />
          } @else {
            <app-non-preview-file [asset]="asset" [version]="version" [gallery]="gallery()"></app-non-preview-file>
          }
        </div>
        <div class="version-info">
          <b class="version-name"
            >{{ names[version.id]?.name }}<span>.{{ names[version.id]?.ext }}</span></b
          >
          <span class="date">
            <app-badge
              [color]="asset.version === version.id ? 'primary' : 'grey-50'"
              [icon]="'/assets/icons/stack.svg'"
            >
              {{ version.version_name || 'v1' | uppercase }}
            </app-badge>
            <span>
              {{
                (version.created_at * 1000 | date: 'MMM d, yyyy') + ' at ' + (version.created_at * 1000 | date: 'HH:mm')
              }}
            </span>
          </span>
        </div>
        @if (selectedVersion.id === version.id) {
          <app-svg src="/assets/icons/eye-open.svg"></app-svg>
        } @else {
          <app-svg src="/assets/icons/arrow-right.svg"></app-svg>
        }
      </a>
    }
  } @else {
    <app-loading-indicator [size]="'small'"></app-loading-indicator>
  }
</div>

@if (showFooter) {
  <div class="gradient-footer">
    @if (galleryPermissions().can_edit) {
      <label
        appButton
        name="add-version"
        location="asset-version-menu"
        color="primary"
        shape="round"
        [hasIcon]="true"
        for="version-replace-upload"
      >
        <app-svg src="/assets/icons/upload.svg"></app-svg>
        <span>Add Version</span>
        <input
          type="file"
          id="version-replace-upload"
          #versionUpload
          class="hidden-input"
          (change)="uploadAssetEvent($event.target)"
          accept="*"
        />
      </label>
    }

    @if (versions?.length > 1 && (asset.type === 'image' || asset.type === 'document')) {
      <a
        [routerLink]="[urlPrefix, asset.version]"
        [queryParams]="{ compareTo: 'auto' }"
        appButton
        name="compare"
        location="asset-version-menu"
        color="simple"
        shape="round"
        [hasIcon]="true"
      >
        <app-svg src="/assets/icons/compare.svg"></app-svg>
        <span>Compare</span>
      </a>
    }
  </div>
}
